module.exports = __webpack_public_path__ + "img/news_title.30ace6a9.svg";